import React, { Component } from "react";
import { Layout } from "antd";
import QueueAnim from "rc-queue-anim";

import bgTech from "../images/bg-tech.jpg";

class loginTemplate extends Component {
	render() {
		return (
			<Layout className="template-login">
				<QueueAnim className="auth-split" type="alpha">
					<div className="auth-split__left" key="left">
						{this.props.children}
					</div>
					<div
						className="auth-split__right"
						key="right"
						style={{ backgroundImage: `url(${bgTech})` }}
					>
						<div className="hero-content">            
						</div>
					</div>
      	</QueueAnim>				
			</Layout>
		)
	}
}

export default loginTemplate;
